// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3Iju0","label":"Category_label__1uqCi","content":"Category_content__DshOd","header":"Category_header__2mUKe","location":"Category_location__8faxg"};